import React, { useEffect, useState } from 'react'
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import './printCauseList.css' 

const CauseListWithoutRegistry = () => {

    const [isLoading, setLoading] = useState(false);
    const [dailyCauseList, setDailyCauseList] = useState([]);
    const [date, setDate] = useState('');
    const [courtLocations, setCourtLocations] = useState([]);
    const [selectedRegistries, setSelectedRegistries] = useState({});
    const [updatingCases, setUpdatingCases] = useState({});

    const dateSuffix = (day) => {
        if ((day == 1) || (day == 21) || (day == 31)) {
            return day + '' + "st";
        } else if ((day == 2) || (day == 22)) {
            return day + '' + "nd";
        } else if ((day == 3) || (day == 23)) {
            return day + '' + "rd";
        } else {
            return day + '' + "th";
        }
    }

    const formattedDate = date && (new Date(date).toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(new Date(date).toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        new Date(date).toLocaleDateString('en-us', { month: "long" }) + ", " + new Date(date).toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const curDate = new Date()
    const dateStr = (curDate.toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(curDate.toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        curDate.toLocaleDateString('en-us', { month: "long" }) + ", " + curDate.toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const alphabetForSisterCase = "abcdefghijklmnopqrstuvwxyz".split("");

    // Fetch court locations from API
    const getCourtLocations = async () => {
        try {
            await endpoint
                .get(`/court-room/list`)
                .then((res) => {
                    const activeLocations = res.data.data?.filter(location => location.status === 1) || [];
                    setCourtLocations(activeLocations);
                    console.log("Active Court Locations", activeLocations);
                })
                .catch((err) => {
                    console.log(err);
                    setCourtLocations([]);
                });
        } catch (error) {
            console.error('Error fetching court locations:', error);
            setCourtLocations([]);
        }
    };

    useEffect(() => {
        getCourtLocations();
    }, []);

    const handleFetchData = async () => {
        setLoading(true)
        await endpoint.get(`/case-diary/new-day-list/${date}`)
            .then(({ data }) => {
                console.log("response with supplied data", data.data)
                let causeArr = data.data
                console.log("return datas to see", causeArr)

                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A';

                    if (!result[location]) {
                        result[location] = {};
                    }

                    const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat + ' ' + (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : '');

                    if (!result[location][key]) {
                        result[location][key] = [];
                    }

                    result[location][key].push(obj);

                    return result;
                }, []);
                console.log("groupedByLocation", groupedByLocation)
                setDailyCauseList(groupedByLocation)

                // Initialize selected registries with current locations
                const initialRegistries = {};
                causeArr.forEach((item, index) => {
                    const caseId = item.firstcase?.case_id || `${index}`;
                    initialRegistries[caseId] = item.location || 'N/A';
                });
                setSelectedRegistries(initialRegistries);

                setLoading(false)
            }).catch((err) => {
                console.log(err)
                setLoading(false)
            })
    }

    // Handle registry change with loading state
    const handleRegistryChange = async (caseId, newRegistry, casediaryId, dateHeld) => {
        // Set loading state for this specific case
        setUpdatingCases(prev => ({ ...prev, [caseId]: true }));
        
        // Store the previous location in case we need to revert
        const previousLocation = selectedRegistries[caseId];
        
        try {
            // Update local state immediately for better UX
            setSelectedRegistries(prev => ({
                ...prev,
                [caseId]: newRegistry
            }));
            
            // Update the actual data in the dailyCauseList
            setDailyCauseList(prevList => {
                const newList = { ...prevList };
                // Find and update the case location in the grouped data
                Object.keys(newList).forEach(location => {
                    Object.keys(newList[location]).forEach(heading => {
                        newList[location][heading] = newList[location][heading].map(item => {
                            if (item.firstcase?.case_id === parseInt(caseId)) {
                                return { ...item, location: newRegistry };
                            }
                            return item;
                        });
                    });
                });
                return newList;
            });

            // Call API to update registry in backend
            const response = await endpoint.put('/case-diary/update-case-diary-location', {
                casediariesID: casediaryId,
                date_held: dateHeld,
                location: newRegistry
            });
            
            if (response.status === 200) {
                console.log('Registry updated successfully:', response.data);
            }
        } catch (error) {
            console.error('Error updating registry:', error);
            
            // Revert the change if API call fails
            setSelectedRegistries(prev => ({
                ...prev,
                [caseId]: previousLocation
            }));
            
            // Revert dailyCauseList
            setDailyCauseList(prevList => {
                const newList = { ...prevList };
                Object.keys(newList).forEach(location => {
                    Object.keys(newList[location]).forEach(heading => {
                        newList[location][heading] = newList[location][heading].map(item => {
                            if (item.firstcase?.case_id === parseInt(caseId)) {
                                return { ...item, location: previousLocation };
                            }
                            return item;
                        });
                    });
                });
                return newList;
            });
            
            // Show error message
            alert('Failed to update registry. Please try again.');
        } finally {
            // Clear loading state for this specific case
            setUpdatingCases(prev => ({ ...prev, [caseId]: false }));
        }
    }

    //function that adds "judgement" to heading
    const splitHeading = (str) => {
        const firstSpaceIndex = str.indexOf(' ')
        const firstPart = str.slice(0, firstSpaceIndex)
        return (firstPart + ' ' + 'Judgment').toUpperCase()
    }

    //function that removes the adjournment id from heading
    const removeNumber = (str) => {
        const result = str.replace(/[0-9]/g, '')
        return (result + ' ' + '(s)').toUpperCase()
    }

    // Helper function to check if registry is N/A (needs selection)
    const isRegistryNA = (registry) => {
        return registry === 'N/A' || registry === '';
    }

    return (
        <>
            {isLoading && <div className="d-flex align-items-center justify-content-center vh-100">
                      <img
                        src={"/loading.gif"}
                        alt={""}
                        className="img-fluid"
                        style={{ maxWidth: "50px" }}
                      />
                    </div>}
            {!isLoading && <div id='divToPrint'>

                <div className='row mt-4'>
                    <div className='col-md-12 text-center' id='hideDate' style={{ textDecoration: `underline` }}> <h3>UPDATE CAUSE LIST REGISTRY </h3><br />
                        </div>
                    <div className='col'>
                        <label className='text-danger' id='hideDate'><i>**Please select date and click on search to print cause list**</i></label>
                        <div className="input-group mb-3" id='hideDate'>
                            <input type="date" className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                            <div className="input-group-append">
                                <button className="btn btn-outline-primary" type="button" onClick={handleFetchData} id="button-addon2">Search</button>
                            </div>
                        </div>

                    </div>
                    <div className='col'>

                    </div>
                </div>

                {isLoading && <Loader />}

                {!isLoading &&
                    <div className='row mt-4'>
                        <div className='col-md-12'>

                            {Object.entries(dailyCauseList).map(([location, groupings], locationIndex) => {
                                // Find the first justiceAssignment in this location group
                                let firstPanel = '';

                                // loop through all case groups under this location to find a panel
                                for (const [_, cases] of Object.entries(groupings)) {
                                    for (const caseItem of cases) {
                                        if (caseItem.justiceAssignment && caseItem.justiceAssignment.length > 0) {
                                            firstPanel = caseItem.justiceAssignment[0].panel || '';
                                            break;
                                        }
                                    }
                                    if (firstPanel) break;
                                }
                                return (<div key={locationIndex}>
                                    {/* Location Header */}
                                    <div className='text-center mb-4' style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
                                        IN THE SUPREME COURT OF NIGERIA<br /> HOLDEN AT ABUJA <br /> CAUSE LIST FOR {date ? formattedDate : dateStr.toUpperCase()} <br />
                                        {location.toUpperCase()} {firstPanel && <span>({firstPanel})</span>}
                                    </div>

                                    {Object.entries(groupings).sort(([keyA], [keyB]) => {
                                        const isMotionA = keyA.toLowerCase().includes("motion");
                                        const isMotionB = keyB.toLowerCase().includes("motion");

                                        if (isMotionA && !isMotionB) return -1;
                                        if (!isMotionA && isMotionB) return 1;

                                        return keyA.localeCompare(keyB);
                                    }).map(([headings, items], index) => (
                                        <div className='causeListHeading' key={index}>
                                            <div className='text-center mb-2' style={{
                                                color: `${headings.toUpperCase().includes("CIVIL") ? 'green' : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`
                                            }}>
                                                {headings.includes(2) ? `${alphabetArray[index]}. ${splitHeading(headings)}` : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                                            </div>

                                            <div className='table-reponsive'>
                                                <table className="table mb-5" style={{ width: `100%` }}>
                                                    <thead className="thead-light">
                                                        <tr style={{ border: `1px solid black` }}>
                                                            <th style={{ maxWidth: `5px`, border: `1px solid black` }}>SN.</th>
                                                            <th scope="col" style={{ border: `1px solid black` }}>APPEAL NO.</th>
                                                            {headings.toUpperCase().includes("APPEAL") ?
                                                                <>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPELLANTS</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>RESPONDENTS</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>REGISTRY</th>
                                                                </>
                                                                : <>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>PARTIES</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>REGISTRY</th>
                                                                </>
                                                            }
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {items.map((item, index) => {
                                                            // Generate a unique ID for this case
                                                            const caseId = item.firstcase?.case_id || `${locationIndex}-${index}`;
                                                            const currentRegistry = selectedRegistries[caseId] || item.location || 'N/A';
                                                            const isUpdating = updatingCases[caseId];
                                                            const isNA = isRegistryNA(currentRegistry);
                                                            
                                                            return (
                                                                <>
                                                                    {item.CaseAttachements && item.CaseAttachements.map((Case, index2) => {
                                                                        const hasSisters = item.CaseAttachements.length > 1;
                                                                        return (
                                                                            <tr key={`${index}-${index2}`} style={{ border: `1px solid black` }}>
                                                                                {(index2 === 0) && <td rowSpan={item.CaseAttachements.length} style={{ border: `1px solid black` }}>{index + 1}.</td>}
                                                                                <td style={{ border: `1px solid black`, color: `${item.CaseType.case_color}` }}>
                                                                                    <strong> {hasSisters ? `${alphabetForSisterCase[index2]}. ${Case.suite_no}` : Case.suite_no}</strong>
                                                                                </td>
                                                                                {headings.toUpperCase().includes("APPEAL") ? (
                                                                                    <>
                                                                                        <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                            <tr>{Case.appellants} {Case.otherAppellantCount === 1 ? (
                                                                                                <><strong> & Anor </strong></>
                                                                                            ) : Case.otherAppellantCount > 1 ? (
                                                                                                <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}</tr>
                                                                                        </td>
                                                                                        <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                            <tr>{Case.respondent}
                                                                                                {Case.otherRespondentCount === 1 ? (
                                                                                                    <><strong> & Anor </strong></>
                                                                                                ) : Case.otherRespondentCount > 1 ? (
                                                                                                    <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                                ) : (
                                                                                                    ""
                                                                                                )}
                                                                                            </tr>
                                                                                        </td>
                                                                                        {/* REGISTRY column for APPEAL cases */}
                                                                                        <td style={{ border: `1px solid black`, textAlign: 'center', padding: '8px' }}>
                                                                                            <select
                                                                                                value={currentRegistry}
                                                                                                onChange={(e) => handleRegistryChange(
                                                                                                    caseId, 
                                                                                                    e.target.value, 
                                                                                                    item.id, // casediariesID from the case diary
                                                                                                    item.date_held
                                                                                                )}
                                                                                                disabled={isUpdating}
                                                                                                className="form-select form-select-sm"
                                                                                                style={{ 
                                                                                                    minWidth: '140px',
                                                                                                    padding: '6px 12px',
                                                                                                    border: '1px solid #ced4da',
                                                                                                    borderRadius: '4px',
                                                                                                    backgroundColor: isUpdating ? '#e9ecef' : '#ffffff',
                                                                                                    color: '#000000',
                                                                                                    fontSize: '14px',
                                                                                                    cursor: isUpdating ? 'not-allowed' : 'pointer',
                                                                                                    opacity: isUpdating ? 0.6 : 1,
                                                                                                    fontWeight: isNA ? 'bold' : 'normal',
                                                                                                    color: isNA ? '#dc3545' : '#000000'
                                                                                                }}
                                                                                            >
                                                                                                {/* Show placeholder only when registry is N/A or empty */}
                                                                                                {isNA && (
                                                                                                    <option value="N/A" style={{ backgroundColor: '#ffffff', color: '#dc3545', fontWeight: 'bold' }}>
                                                                                                        -- Select Registry --
                                                                                                    </option>
                                                                                                )}
                                                                                                {courtLocations.length > 0 ? (
                                                                                                    courtLocations.map((location) => (
                                                                                                        <option 
                                                                                                            key={location.id} 
                                                                                                            value={location.name}
                                                                                                            style={{ 
                                                                                                                backgroundColor: '#ffffff',
                                                                                                                color: '#000000'
                                                                                                            }}
                                                                                                        >
                                                                                                            {location.name}
                                                                                                        </option>
                                                                                                    ))
                                                                                                ) : (
                                                                                                    <option value="N/A" style={{ backgroundColor: '#ffffff', color: '#000000' }}>
                                                                                                        No locations available
                                                                                                    </option>
                                                                                                )}
                                                                                            </select>
                                                                                            {isUpdating && (
                                                                                                <span style={{ marginLeft: '8px', color: '#0066cc' }}>
                                                                                                    <i className="fas fa-spinner fa-spin"></i>
                                                                                                </span>
                                                                                            )}
                                                                                            {isNA && (
                                                                                                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
                                                                                            )}
                                                                                        </td>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <td className='text-center' style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                            <tr>{Case.appellants}{Case.otherAppellantCount === 1 ? (
                                                                                                <><strong> & Anor </strong></>
                                                                                            ) : Case.otherAppellantCount > 1 ? (
                                                                                                <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}</tr>
                                                                                            <tr><div className='mt-2 mb-2'>VS.</div></tr>
                                                                                            <tr>{Case.respondent}{Case.otherRespondentCount === 1 ? (
                                                                                                <><strong> & Anor </strong></>
                                                                                            ) : Case.otherRespondentCount > 1 ? (
                                                                                                <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}</tr>
                                                                                        </td>
                                                                                        <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word` }}>
                                                                                            {Case.caseDescriptions && Case.caseDescriptions.map((desc, descIndex) => ( 
                                                                                                <>
                                                                                                    <br></br>
                                                                                                    <tr style={{margin: '10px !important'}}>
                                                                                                        {descIndex + 1}. {desc?.description} 
                                                                                                    </tr>
                                                                                                </>
                                                                                            ))}
                                                                                        </td>
                                                                                        {/* REGISTRY column for non-APPEAL cases */}
                                                                                        <td style={{ border: `1px solid black`, textAlign: 'center', padding: '8px' }}>
                                                                                            <select
                                                                                                value={currentRegistry}
                                                                                                onChange={(e) => handleRegistryChange(
                                                                                                    caseId, 
                                                                                                    e.target.value, 
                                                                                                    item.id, // casediariesID from the case diary
                                                                                                    item.date_held
                                                                                                )}
                                                                                                disabled={isUpdating}
                                                                                                className="form-select form-select-sm"
                                                                                                style={{ 
                                                                                                    minWidth: '140px',
                                                                                                    padding: '6px 12px',
                                                                                                    border: '1px solid #ced4da',
                                                                                                    borderRadius: '4px',
                                                                                                    backgroundColor: isUpdating ? '#e9ecef' : '#ffffff',
                                                                                                    color: '#000000',
                                                                                                    fontSize: '14px',
                                                                                                    cursor: isUpdating ? 'not-allowed' : 'pointer',
                                                                                                    opacity: isUpdating ? 0.6 : 1,
                                                                                                    fontWeight: isNA ? 'bold' : 'normal',
                                                                                                    color: isNA ? '#dc3545' : '#000000'
                                                                                                }}
                                                                                            >
                                                                                                {/* Show placeholder only when registry is N/A or empty */}
                                                                                                {isNA && (
                                                                                                    <option value="N/A" style={{ backgroundColor: '#ffffff', color: '#dc3545', fontWeight: 'bold' }}>
                                                                                                        -- Select Registry --
                                                                                                    </option>
                                                                                                )}
                                                                                                {courtLocations.length > 0 ? (
                                                                                                    courtLocations.map((location) => (
                                                                                                        <option 
                                                                                                            key={location.id} 
                                                                                                            value={location.name}
                                                                                                            style={{ 
                                                                                                                backgroundColor: '#ffffff',
                                                                                                                color: '#000000'
                                                                                                            }}
                                                                                                        >
                                                                                                            {location.name}
                                                                                                        </option>
                                                                                                    ))
                                                                                                ) : (
                                                                                                    <option value="N/A" style={{ backgroundColor: '#ffffff', color: '#000000' }}>
                                                                                                        No locations available
                                                                                                    </option>
                                                                                                )}
                                                                                            </select>
                                                                                            {isUpdating && (
                                                                                                <span style={{ marginLeft: '8px', color: '#0066cc' }}>
                                                                                                    <i className="fas fa-spinner fa-spin"></i>
                                                                                                </span>
                                                                                            )}
                                                                                            {isNA && (
                                                                                                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
                                                                                            )}
                                                                                        </td>
                                                                                    </>
                                                                                )}
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </>
                                                            )
                                                        })}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )})}


                        </div>
                    </div>
                }

                {Object.entries(dailyCauseList).length > 0 &&
                    <div className='col-md-12 hideBtn'>
                        <button className="btn btn-outline-primary" type="button" onClick={() => window.print()} id="button-addon2">Print</button>
                    </div>
                }

            </div>}
        </>

    )
}

export default CauseListWithoutRegistry